import styled from 'libs/styled';

const Polygon = styled('polygon')``;

export default Polygon;
